import React from "react";

class Questions_Table_IPAQ extends React.Component {
  constructor(props) {
    super(props);
    this.state = props.data || {};
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data && this.props.data) {
      this.setState(this.props.data);
    }
  }

  // Clear dependent duration question when a days field drops to 0 / empty
  handleChange = (e) => {
    const { name, value } = e.target;
    let updated = { ...this.state, [name]: value };

    const clearOnZero = {
      ipaq_1: ["ipaq_2"],
      ipaq_3: ["ipaq_4"],
      ipaq_5: ["ipaq_6"],
    };

    if (clearOnZero[name] && (!value || parseInt(value, 10) === 0)) {
      clearOnZero[name].forEach((key) => { updated[key] = ""; });
    }

    this.setState(updated, () => {
      if (this.props.handler) {
        this.props.handler(updated);
      }
    });
  };

  // Toggle "δεν γνωρίζω" checkbox; stores "Unknown" in the question's own field
  handleUnknownChange = (id, checked) => {
    const updated = { ...this.state, [id]: checked ? "Unknown" : "" };
    this.setState(updated, () => {
      if (this.props.handler) {
        this.props.handler(updated);
      }
    });
  };

  // A question with disabled_by is greyed out when its parent days field = 0 / empty
  isQuestionDisabled = (q) => {
    if (this.props.disabled) return true;
    if (q.disabled_by) {
      const parentVal = this.state[q.disabled_by];
      if (!parentVal || parseInt(parentVal, 10) === 0) return true;
    }
    return false;
  };

  getQuestionNumber = (id) => parseInt(id.replace("ipaq_", ""));

  renderSectionHeader = (header) => (
    <tr style={{ backgroundColor: "#e3f2fd" }}>
      <td colSpan={2} style={{ padding: "16px" }}>
        <strong><em>{header}</em></strong>
      </td>
    </tr>
  );

  // Numeric input row + optional "δεν γνωρίζω" checkbox
  renderAnswerField = (q, isDisabled) => {
    const isUnknown     = this.state[q.id] === "Unknown";
    const inputDisabled = isDisabled || isUnknown || this.props.disabled;

    const maxVal =
      q.type === "days_per_week"   ? 7  :
      q.type === "hours_per_day"   ? 24 : 960;

    const unit =
      q.type === "days_per_week"   ? "ημέρες ανά εβδομάδα" :
      q.type === "minutes_per_day" ? "λεπτά ανά ημέρα"     :
      q.type === "hours_per_day"   ? "ώρες ανά ημέρα"      : "";

    return (
      <div style={{ display: "flex", alignItems: "center", gap: "20px", flexWrap: "wrap" }}>
        {/* Numeric input + unit label */}
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <input
            type="number"
            name={q.id}
            value={isUnknown ? "" : (this.state[q.id] || "")}
            onChange={this.handleChange}
            disabled={inputDisabled}
            min={0}
            max={maxVal}
            style={{
              width: "80px",
              padding: "8px",
              border: "1px solid #ced4da",
              borderRadius: "4px",
              fontSize: "16px",
              textAlign: "center",
              opacity: inputDisabled ? 0.45 : 1,
              backgroundColor: inputDisabled ? "#f8f9fa" : "white",
              cursor: inputDisabled ? "not-allowed" : "auto",
            }}
          />
          {unit && (
            <span style={{ fontSize: "14px", color: isDisabled ? "#adb5bd" : "#495057" }}>
              {unit}
            </span>
          )}
        </div>

        {/* "Don't know" checkbox — hidden when the whole row is skipped */}
        {q.has_unknown && !isDisabled && (
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              fontSize: "14px",
              cursor: this.props.disabled ? "not-allowed" : "pointer",
              padding: "6px 12px",
              border: `1px solid ${isUnknown ? "#6c757d" : "#ced4da"}`,
              borderRadius: "4px",
              backgroundColor: isUnknown ? "#e9ecef" : "white",
              userSelect: "none",
            }}
          >
            <input
              type="checkbox"
              checked={isUnknown}
              onChange={(e) => this.handleUnknownChange(q.id, e.target.checked)}
              disabled={this.props.disabled}
              style={{
                cursor: this.props.disabled ? "not-allowed" : "pointer",
                width: "16px",
                height: "16px",
              }}
            />
            δεν γνωρίζω/δεν είμαι βέβαιος
          </label>
        )}
      </div>
    );
  };

  renderDefaultQuestion = (q) => {
    const questionNumber = this.getQuestionNumber(q.id);
    const isDisabled     = this.isQuestionDisabled(q);

    return (
      <React.Fragment key={q.id}>
        {q.section_header && this.renderSectionHeader(q.section_header)}

        {/* Question text row */}
        <tr>
          <td
            colSpan={2}
            style={{
              position: "relative",
              padding: "16px",
              backgroundColor: "#f8f9fa",
              opacity: isDisabled ? 0.5 : 1,
            }}
          >
            <span
              style={{
                position: "absolute",
                top: "16px",
                left: "16px",
                backgroundColor: isDisabled ? "#adb5bd" : "#007bff",
                color: "white",
                padding: "4px 8px",
                borderRadius: "4px",
                fontSize: "12px",
                fontWeight: "bold",
              }}
            >
              {questionNumber}
            </span>
            <div style={{ marginLeft: "50px" }}>
              <strong>{q.question}</strong>
              {q.note && (
                <div style={{ marginTop: "8px", color: "#6c757d", fontSize: "13px", fontStyle: "italic" }}>
                  {q.note}
                </div>
              )}
            </div>
          </td>
        </tr>

        {/* Answer row */}
        <tr>
          <td
            colSpan={2}
            style={{
              paddingLeft: "66px",
              paddingRight: "16px",
              paddingTop: "12px",
              paddingBottom: "16px",
              backgroundColor: isDisabled ? "#f8f9fa" : "white",
            }}
          >
            {this.renderAnswerField(q, isDisabled)}
          </td>
        </tr>
      </React.Fragment>
    );
  };

  // Kept for backwards compatibility (long-form job questions)
  renderJobQuestion = (q) => {
    const questionNumber = this.getQuestionNumber(q.id);
    return (
      <React.Fragment key={q.id}>
        <tr style={{ backgroundColor: "#f8f9fa" }}>
          <th colSpan={2} style={{ position: "relative", padding: "16px" }}>
            <span
              style={{
                position: "absolute",
                top: "12px",
                left: "16px",
                backgroundColor: "#495057",
                color: "white",
                padding: "4px 8px",
                borderRadius: "4px",
                fontSize: "12px",
                fontWeight: "bold",
              }}
            >
              {questionNumber}
            </span>
            <div style={{ marginLeft: "50px" }}>{q.question}</div>
          </th>
        </tr>
        {q.jobs.map((job, idx) => (
          <React.Fragment key={`job-${idx}`}>
            <tr>
              <td style={{ width: "30%", verticalAlign: "top", padding: "16px", fontWeight: "500" }}>
                {job.job}
              </td>
              <td style={{ width: "70%", padding: "16px" }}>
                <select
                  name={`${q.id}_${job.job.replace(/\s+/g, "_")}`}
                  value={this.state[`${q.id}_${job.job.replace(/\s+/g, "_")}`] || ""}
                  onChange={this.handleChange}
                  disabled={this.props.disabled}
                  style={{
                    width: "100%",
                    padding: "8px 12px",
                    border: "1px solid #ced4da",
                    borderRadius: "4px",
                    fontSize: "14px",
                    backgroundColor: "white",
                    color: "#495057",
                  }}
                >
                  <option value="">Επιλέξτε</option>
                  {job.options.map((opt, i) => (
                    <option key={i} value={opt}>{opt}</option>
                  ))}
                </select>
              </td>
            </tr>
          </React.Fragment>
        ))}
      </React.Fragment>
    );
  };

  // Kept for reference; no longer called from handleChange or rendered
  calculateIPAQScore = (data = this.state) => {
    const getNum = (val) => parseInt(val) || 0;
    const clamp  = (m) => m < 10 ? 0 : m > 180 ? 180 : m;

    const vigDays  = getNum(data.ipaq_1);
    const vigMin   = clamp(getNum(data.ipaq_2));
    const modDays  = getNum(data.ipaq_3);
    const modMin   = clamp(getNum(data.ipaq_4));
    const walkDays = getNum(data.ipaq_5);
    const walkMin  = clamp(getNum(data.ipaq_6));

    const vigMET   = vigDays  * vigMin  * 8.0;
    const modMET   = modDays  * modMin  * 4.0;
    const walkMET  = walkDays * walkMin * 3.3;
    const totalMET = vigMET + modMET + walkMET;

    const sumDays = vigDays + modDays + walkDays;
    let category = "Low";
    if ((vigDays >= 3 && totalMET >= 1500) || (sumDays >= 7 && totalMET >= 3000)) {
      category = "High";
    } else if (
      (vigDays >= 3 && vigMin >= 20) ||
      (modDays >= 5 && modMin >= 30) ||
      (walkDays >= 5 && walkMin >= 30) ||
      (sumDays >= 5 && totalMET >= 600)
    ) {
      category = "Moderate";
    }

    return { vigMET, modMET, walkMET, totalMET, category };
  };

  render() {
    const { questions } = this.props;

    return (
      <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "20px" }}>
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: "32px" }}>
          <h2 style={{ marginBottom: "8px", color: "#495057" }}>
            International Physical Activity Questionnaire (IPAQ)
          </h2>
          <p style={{ color: "#6c757d", fontSize: "14px" }}>
            Short Form · Greek Version (7 items)
          </p>
        </div>

        {/* Questions table */}
        <table
          style={{
            width: "100%",
            border: "1px solid #dee2e6",
            borderCollapse: "collapse",
            backgroundColor: "white",
            marginBottom: "32px",
          }}
        >
          <tbody>
            {questions.map((q) => {
              if (q.jobs) return this.renderJobQuestion(q);
              return this.renderDefaultQuestion(q);
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

Questions_Table_IPAQ.defaultProps = {
  data: {},
  handler: null,
  disabled: false,
  questions: [
    {
      id: "ipaq_1",
      question: "1. Κατά τις τελευταίες 7 ημέρες, πόσες ημέρες κάνατε κάποια έντονη σωματική δραστηριότητα, όπως σκάψιμο, έντονη άσκηση με βάρη, τρέξιμο σε διάδρομο με κλίση, γρήγορο τρέξιμο, aerobics, γρήγορη ποδηλασία, γρήγορη κολύμβηση, τένις μονό, αγώνας σε γήπεδο (ποδόσφαιρο, basketball-μπάσκετ, volleyball-βόλεϊ, κλπ);",
      type: "days_per_week",
      note: "εάν δεν κάνατε έντονες σωματικές δραστηριότητες, τότε προχωρήστε στην ερώτηση 3",
    },
    {
      id: "ipaq_2",
      question: "2. Τις ημέρες που κάνατε κάποια έντονη σωματική δραστηριότητα, πόσο χρόνο αφιερώνατε συνήθως;",
      type: "minutes_per_day",
      has_unknown: true,
      disabled_by: "ipaq_1",
    },
    {
      id: "ipaq_3",
      question: "3. Κατά τις τελευταίες 7 ημέρες, πόσες ημέρες κάνατε κάποια μέτρια σωματική δραστηριότητα, όπως το να σηκώσετε και να μεταφέρετε ελαφρά βάρη (λιγότερο από 10 κιλά), συνολική καθαριότητα του σπιτιού, ήπιες ρυθμικές ασκήσεις σώματος, ποδηλασία αναψυχής με χαμηλή ταχύτητα, χαλαρή κολύμβηση; Σας παρακαλώ να μη συμπεριλάβετε το περπάτημα.",
      type: "days_per_week",
      note: "εάν δεν κάνατε μέτριας έντασης σωματικές δραστηριότητες, τότε προχωρήστε στην ερώτηση 5",
    },
    {
      id: "ipaq_4",
      question: "4. Τις ημέρες που κάνατε κάποια μέτρια σωματική δραστηριότητα, πόσο χρόνο αφιερώνατε συνήθως;",
      type: "minutes_per_day",
      has_unknown: true,
      disabled_by: "ipaq_3",
    },
    {
      id: "ipaq_5",
      question: "5. Κατά τις τελευταίες 7 ημέρες, πόσες ημέρες περπατήσατε για περισσότερο από 10 συνεχόμενα λεπτά;",
      type: "days_per_week",
      note: "εάν δεν περπατήσατε καμία φορά περισσότερο από 10 συνεχόμενα λεπτά, τότε προχωρήστε στην ερώτηση 7",
    },
    {
      id: "ipaq_6",
      question: "6. Τις ημέρες που περπατήσατε, για περισσότερο από 10 συνεχόμενα λεπτά, πόσο χρόνο περάσατε περπατώντας;",
      type: "minutes_per_day",
      has_unknown: true,
      disabled_by: "ipaq_5",
    },
    {
      id: "ipaq_7",
      question: "7. Κατά τις τελευταίες 7 ημέρες, πόσο χρόνο περάσατε καθισμένος/η σε μια συνηθισμένη μέρα; Ο χρόνος αυτός μπορεί να περιλαμβάνει το χρόνο που περνάτε καθισμένος/η στο σπίτι, στο γραφείο, στο αυτοκίνητο, όταν διαβάζετε, όταν είστε με φίλους, ξεκουράζεστε σε πολυθρόνα ή βλέπετε τηλεόραση, αλλά δεν περιλαμβάνει τον ύπνο.",
      type: "hours_per_day",
      has_unknown: true,
    },
  ],
};

export default Questions_Table_IPAQ;
